import type { z } from "zod";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200);
const zRes400 = Response.Schema.zUnsuccessful(400);
const zRes401 = Response.Schema.zNoBody(401);

const zRes = Response.Schema.zAggregated([zRes200, zRes400, zRes401]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
